import { AbstractControl, Validators } from '@angular/forms';

export function requiredConditionalValidator(callback: (control: AbstractControl) => boolean) {
  return (control: AbstractControl) => callback(control) ? Validators.required(control) : null;
}
